import * as Yup from 'yup';
import { validationMessages, WEB_URL_REGEX } from '../../../../../utils/Constants';

export const validationSchemaCO_LegalRepresentative = (t) =>
  Yup.object().shape({
    fullName: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(40, t(validationMessages.maxLength, { amount: 40 })),
    email: Yup.string().email(t('validationEmailSpanish')).required(t(validationMessages.requiredSpanish)),
    rfc: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(8, t(validationMessages.minLength, { amount: 8 }))
      .max(10, t(validationMessages.maxLength, { amount: 10 })),
    fullAddress: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(128, t(validationMessages.maxLength, { amount: 128 })),
  });
export const validationSchemaCO_Company = (t) =>
  Yup.object().shape({
    commercialName: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(40, t(validationMessages.maxLength, { amount: 40 })),
    legalName: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(40, t(validationMessages.maxLength, { amount: 40 })),
    rfc: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(10, t(validationMessages.minLength, { amount: 10 }))
      .max(11, t(validationMessages.maxLength, { amount: 11 })),
    clabe: Yup.number()
      .required(t('numericValidationRequiredSpanish'))
      .test('len', 'La CLABE debe ser de hasta 18 números', (val) => {
        if (!val || !val.toString()) return false;
        return val.toString().length <= 18;
      }),
    fullAddress: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(128, t(validationMessages.maxLength, { amount: 128 })),
    city: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(128, t(validationMessages.maxLength, { amount: 128 })),
    country: Yup.string().required(t(validationMessages.requiredSpanish)),
    web: Yup.string().required(t(validationMessages.requiredSpanish)).matches(WEB_URL_REGEX, t('validationUrl')),
    proofOfTaxSituation: Yup.mixed().required(t(validationMessages.requiredSpanish)),
    zipCode: Yup.string().required(t(validationMessages.requiredSpanish)),
    bank: Yup.string().required(t(validationMessages.requiredSpanish)),
    accountType: Yup.string().required(t(validationMessages.requiredSpanish)),
    nit: Yup.string().required(t(validationMessages.requiredSpanish)),
  });
